import Vue from 'vue';

Vue.directive('focus', {
    inserted(el, binding, vnode){
        setTimeout(()=> {
            el.querySelector('input').focus()
        },0)
        
    }
})


// WEBPACK FOOTER //
// ./src/directive/focus.js